import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getBusinessStripeSummary } from '../../services/business';
import { canManageStripeAccount } from '../../helpers/businesses';

function useStripeSummary() {
  const { user } = useUser();

  return useQuery({
    queryKey: ['stripe-summary', user?.business?.id, user?.userId, user?.role],
    queryFn: () => getBusinessStripeSummary(user?.business?.id!),
    enabled: canManageStripeAccount(user),
  });
}

export default useStripeSummary;
